<template>



    <div class="home">

        <div class="homebg" v-if="step==0">
            <img src="../static/hometop.png" class="hometop" alt="">
      
        <img src="../static/hometitle.png" class="hometitle" alt="">
        <img src="../static/hometips.png" class="hometips" alt="">
      <img src="../static/homebut.png" v-show="thebut" @click="toletter" class="but" alt="">
        </div>
        

        <!-- <Letter  class="theletter" v-if="step==1"  @child-event="tomap"></Letter>
        <Map class="themap" v-if="step==2" ></Map> -->
    </div>
</template>

<script>

// import Letter from './letter.vue';
// import Map from './map.vue';
export default {
    //   components: {
    //     Letter,
    //     Map
    // },
    data() {
        return {
            thebut:false,
            step:0
        }
    },
    methods: {
        toletter(){
            this.$router.push("letter")
            // this.step=1
        },
        // tomap(){
        //     this.step=2
        // }
    },
    mounted() {
        setTimeout(() => {
            this.thebut=true
        }, 2500);
    },
}
</script>

<style lang="less">
.home {
    width: 100%;
    height: 100%;
    position: relative;
    .theletter{
        z-index: 5;
        position: absolute;
        top: 0;
        left: 0;
    }
    .themap{
        z-index: 2;
        position: absolute;
        top: 0;
        left: 0;
    }
    .homebg{
            width: 375px;
    height: 100vh;
    background: url("../static/homebg.png") no-repeat;
    background-size: 100% 100%;
    position: relative;
    overflow: hidden;
        z-index: 10;
        .hometop{
        position: absolute;
        top: 0;
        width: 100%;
           animation: an-hometop 1s ease-in 1 normal;

        @keyframes an-hometop {
            0% {
               top:-100px
            }

            100% {
               top: 0;
            }
        }
    }

  

    .hometitle {
        position: absolute;
        width: 290px;
        left: 50%;
        margin-left: -145px;
        top: 130px;
        animation: an-title 2s ease-out 1 normal;

        @keyframes an-title {
            0% {
           
                opacity: 0;

            }

            40% {
                transform: scale(0.2);
                opacity: 0;
            }

            100% {
                transform: scale(1);
                opacity: 1;

            }
        }
    }

    .hometips{
        position: absolute;
        width:160px;
        left: 50%;
        margin-left: -80px;
        top: 320px;
         animation: an-tips 3s ease-out 1 normal;

        @keyframes an-tips {
            0% {
           
                opacity: 0;

            }

            60% {
                
                opacity: 0;
            }

            100% {
                
                opacity: 1;

            }
        }
    }

    .but {
        position: absolute;
        width: 110px;
        bottom: 7%;
        margin-left: -55px;
        left: 50%;
        animation: thebut 1.5s linear infinite;

        @keyframes thebut {
            0% {
                transform: scale(1);
            }

            50% {
                transform: scale(1.1);
            }

            100% {
                transform: scale(1);
            }
        }
    }
    }

    
}
</style>